import { Tag } from "primereact/tag";

import { StatusPeriod } from "../../../types/alerting";
import { formatInstant } from "../../../utils/instantFormat";

/** Ties a status period to the alert it raised. Renders nothing when it raised none. */
const AlertMarkers = ({ period }: { period: StatusPeriod }) => {
  if (!period.alertedAt && !period.remindedAt) return null;

  return (
    <div className="flex flex-column gap-2" data-testid="alert-markers">
      {period.alertedAt && (
        <div className="flex align-items-center gap-2" data-testid="alert-marker">
          <Tag
            severity="danger"
            icon="pi pi-exclamation-triangle"
            value={period.alertScope ? `Alerted · ${period.alertScope}` : "Alerted"}
          />
          <span className="text-xs text-color-secondary">{formatInstant(period.alertedAt)}</span>
        </div>
      )}

      {period.remindedAt && (
        <div className="flex align-items-center gap-2" data-testid="reminder-marker">
          <Tag severity="warning" icon="pi pi-bell" value="Reminded" />
          <span className="text-xs text-color-secondary">{formatInstant(period.remindedAt)}</span>
        </div>
      )}
    </div>
  );
};

export default AlertMarkers;
